module.exports = __webpack_public_path__ + "img/opreationLog.47b5746a.svg";